import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';

import { useDisclosure, useToast } from '@chakra-ui/react';

import { updateGroup } from 'api/groups';
import { useMutation, useQueryClient } from 'react-query';

import { washHub } from 'store/slices';

import { Group } from 'types/groups';
import { RefType, EditGroupModalProps } from './EditGroupModal.props';

import EditGroupModalView from './EditGroupModal.view';

const Container = forwardRef<RefType, EditGroupModalProps>((props, ref) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const [group, setGroup] = useState<Group | null>(null);

  const washHubs = washHub.selectors.useAllWashHubs();
  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { isOpen, onOpen, onClose } = useDisclosure();

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (_group) => {
        setGroup(_group);

        onOpen();
      },
    }),
    [onOpen],
  );

  const { mutate, isLoading } = useMutation(
    (payload: any) => updateGroup(payload, String(group?._id)),
    {
      onSuccess: () => {
        toast({
          title: 'Group updated',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        queryClient.invalidateQueries({
          queryKey: [`fetch-groups-${washHubId}`],
        });

        onClose();
      },
    },
  );

  const _props = {
    group,
    isOpen,
    onClose,
    washHubs,
    isLoading,
    onUpdate: async (payload: any) => {
      mutate(payload);
    },
  };

  return <EditGroupModalView {..._props} />;
});

const EditGroupModal = memo(Container);

export default EditGroupModal;
